/* bal-pdp.js - vanilla gallery + purchase-type toggle + rotating quote + facts zoom */
(function () {
  'use strict';

  function initGallery(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-thumb]'));
    if (!slides.length) return;
    var current = 0;
    slides.forEach(function (el, idx) {
      if (el.classList.contains('--active')) current = idx;
    });

    function go(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (el, idx) {
        var active = idx === current;
        var wrap = el.closest('.v4-pdp__main-zoom') || el;
        wrap.classList.toggle('--active', active);
        el.classList.toggle('--active', active);
        el.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (wrap.matches('.v4-pdp__main-zoom')) {
          wrap.setAttribute('aria-hidden', active ? 'false' : 'true');
          wrap.tabIndex = active ? 0 : -1;
        }
        if (active && el.tagName === 'IMG') el.alt = el.getAttribute('data-alt') || el.alt;
      });
      thumbs.forEach(function (t, idx) {
        t.classList.toggle('--active', idx === current);
        t.setAttribute('aria-selected', idx === current ? 'true' : 'false');
      });
      var activeThumb = thumbs[current];
      if (activeThumb && activeThumb.scrollIntoView) {
        try { activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); } catch (e) { /* noop */ }
      }
    }

    slides.forEach(function (el) {
      if (el.tagName === 'IMG' && el.alt) el.setAttribute('data-alt', el.alt);
    });

    thumbs.forEach(function (t, idx) {
      t.addEventListener('click', function () { go(idx); });
    });
    var prev = root.querySelector('[data-pdp-prev]');
    var next = root.querySelector('[data-pdp-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });

    /* Reset to hero slide when the gallery leaves the viewport (homepage + PDP). */
    var gallery = root.querySelector('[data-pdp-gallery]');
    if (gallery && gallery.hasAttribute('data-pdp-reset-on-leave') && 'IntersectionObserver' in window) {
      var watchTarget = root.querySelector('.v4-pdp__media') || gallery;
      var sawSection = false;
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              sawSection = true;
              return;
            }
            if (sawSection && current !== 0) {
              go(0);
            }
            sawSection = false;
          });
        },
        { threshold: 0 },
      );
      observer.observe(watchTarget);
    }
  }

  /*
   * Gallery zoom. The markup for this shipped in bal-v4-pdp-gallery.liquid
   * (a [data-pdp-slide-zoom] button around every non-hero slide, plus a
   * [data-pdp-zoom-popup] dialog with a close control), and the CSS shipped in
   * bal-pdp.css, but NOTHING ever bound them: clicking the zoom control did
   * nothing and the popup could not open. PR #83 fixed the popup img's src to a
   * 1x1 placeholder, which removed the broken-image symptom without giving the
   * control anything to do. This is the missing binding.
   *
   * The full-size source is the slide's own asset_url: the gallery renders it
   * at 900x900 CSS pixels but the asset itself is unscaled, so opening it in
   * the popup (object-fit: contain over the whole gallery frame) is a genuine
   * enlargement, not a re-render of the same pixels.
   */
  var ZOOM_PLACEHOLDER =
    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

  function initSlideZoom(scope) {
    var popup = scope.querySelector('[data-pdp-zoom-popup]');
    var triggers = Array.prototype.slice.call(scope.querySelectorAll('[data-pdp-slide-zoom]'));
    if (!popup || !triggers.length) return;
    var img = popup.querySelector('.v4-pdp__zoom-popup__img');
    var closeBtn = popup.querySelector('[data-pdp-zoom-close]');
    var lastTrigger = null;

    function open(trigger) {
      var inner = trigger.querySelector('img');
      var src = inner && (inner.currentSrc || inner.src);
      if (!src) return;
      if (img) {
        img.src = src;
        img.alt = inner.getAttribute('data-alt') || inner.alt || trigger.getAttribute('aria-label') || '';
      }
      lastTrigger = trigger;
      popup.hidden = false;
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      if (popup.hidden) return;
      popup.hidden = true;
      /* Drop the large image so a reopen cannot flash the previous slide. */
      if (img) {
        img.src = ZOOM_PLACEHOLDER;
        img.alt = '';
      }
      if (lastTrigger) {
        try { lastTrigger.focus(); } catch (e) { /* noop */ }
        lastTrigger = null;
      }
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        open(trigger);
      });
    });

    /* The popup is cursor: zoom-out over its whole surface, so any click in it
       dismisses -- including the close button, which stops propagation only to
       keep the two handlers from firing twice. */
    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        close();
      });
    }
    popup.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && !popup.hidden) close();
    });

    /* aria-modal is a promise about focus. The dialog holds exactly one
       focusable control, so keep Tab on it rather than letting focus escape to
       the page behind an overlay the reader cannot see past. */
    popup.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      e.preventDefault();
      if (closeBtn) closeBtn.focus();
    });
  }
  function initFactsZoom(scope) {
    var zoomBtns = scope.querySelectorAll('[data-pdp-facts-zoom]');
    var lightbox = document.getElementById('v4-pdp-facts-lightbox');
    if (!zoomBtns.length || !lightbox) return;
    var img = lightbox.querySelector('.v4-facts-lightbox__img');
    var closeBtn = lightbox.querySelector('.v4-facts-lightbox__close');

    function open(src) {
      if (img) img.src = src;
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      lightbox.hidden = true;
      document.body.style.overflow = '';
    }

    zoomBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var inner = btn.querySelector('img');
        if (inner && inner.src) open(inner.src);
      });
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target.classList.contains('v4-facts-lightbox__close')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lightbox.hidden) close();
    });
  }

  function initPurchase(root) {
    var radios = Array.prototype.slice.call(root.querySelectorAll('input[name="bal_purchase_type"]'));
    if (!radios.length) return;
    var planInput = root.querySelector('[data-pdp-selling-plan]');
    var priceOut = root.querySelector('[data-pdp-atc-price]');
    function sync() {
      var checked = radios.filter(function (r) { return r.checked; })[0];
      if (!checked) return;
      radios.forEach(function (r) {
        var tile = r.closest('.v4-pdp__purchase-tile');
        if (tile) tile.classList.toggle('--active', r.checked);
      });
      var isSub = checked.value !== 'one-time';
      if (planInput) {
        if (isSub) {
          planInput.value = checked.value;
          planInput.disabled = false;
        } else {
          planInput.value = '';
          planInput.disabled = true;
        }
      }
      if (priceOut && checked.getAttribute('data-price')) {
        priceOut.textContent = checked.getAttribute('data-price');
      }
      document.dispatchEvent(new CustomEvent('v4:purchase-changed'));
    }
    radios.forEach(function (r) { r.addEventListener('change', sync); });
    sync();
  }

  function initQuotes(root) {
    var quotes = Array.prototype.slice.call(root.querySelectorAll('.v4-pdp__trust-quote-item'));
    if (quotes.length < 2) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    var idx = 0;
    setInterval(function () {
      idx = (idx + 1) % quotes.length;
      quotes.forEach(function (q, i) {
        q.classList.toggle('--active', i === idx);
        q.setAttribute('aria-hidden', i === idx ? 'false' : 'true');
      });
    }, 5000);
  }

  function boot() {
    var root = document.querySelector('.bal-pdp');
    if (root) {
      initGallery(root);
      initFactsZoom(root);
      initSlideZoom(root);
      initPurchase(root);
      initQuotes(root);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
